import { UserOnboarding } from "types/userTypes";

export const ONBOARDING_PATH = "/onboarding";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

// The backend only attaches `onboarding` to users enrolled in device allocation.
export const parseUserOnboarding = (value: unknown): UserOnboarding | null => {
  if (!isRecord(value)) return null;
  const { onboard, licenseCount } = value;
  if (typeof onboard !== "boolean" || typeof licenseCount !== "number") return null;
  return { onboard, licenseCount: Math.max(0, Math.floor(licenseCount)) };
};

export const shouldRedirectToOnboarding = (
  onboarding: UserOnboarding | null | undefined,
): boolean => onboarding?.onboard === true;

export const hasOnboardingLicenses = (onboarding: UserOnboarding | null | undefined): boolean =>
  !!onboarding && onboarding.licenseCount > 0;

export const resolvePostLoginPath = (
  onboarding: UserOnboarding | null | undefined,
  fallbackPath: string,
): string => (shouldRedirectToOnboarding(onboarding) ? ONBOARDING_PATH : fallbackPath);

export const onboardingAfterDeviceAdded = (onboarding: UserOnboarding): UserOnboarding => {
  const licenseCount = Math.max(0, onboarding.licenseCount - 1);
  return { onboard: licenseCount > 0 && onboarding.onboard, licenseCount };
};
